module.exports = __webpack_public_path__ + "res/25-img_game_bg_m.8d8524e8aa43ee63b104c10ff705a5bf.png";